/* SignKingdom Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  /* ===== Hero Slider ===== */
  const hero = document.querySelector('.sk-hero');
  if (hero) {
    const track = hero.querySelector('.sk-hero-track');
    const slides = hero.querySelectorAll('.sk-hero-slide');
    const dots = hero.querySelectorAll('.sk-hero-dot');
    const prevBtn = hero.querySelector('.sk-hero-arrow--prev');
    const nextBtn = hero.querySelector('.sk-hero-arrow--next');
    let current = 0;
    const total = slides.length;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); }); });
    setInterval(function() { goTo(current + 1); }, 5000);
  }

  /* ===== Category Tabs (カテゴリー別おすすめ) ===== */
  var cattabWraps = document.querySelectorAll('[data-cattabs]');
  cattabWraps.forEach(function(wrap) {
    var tabs = wrap.querySelectorAll('.sk-cattab');
    var panels = wrap.querySelectorAll('.sk-cattab-panel');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var target = tab.getAttribute('data-tab');
        panels.forEach(function(p) {
          p.classList.toggle('active', p.getAttribute('data-panel') === target);
        });
      });
    });
  });

  /* ===== Industry Tabs ===== */
  var industryTabs = document.querySelectorAll('[data-industry-tabs]');
  industryTabs.forEach(function(wrap) {
    var tabs = wrap.querySelectorAll('.sk-industry-tab');
    var section = wrap.closest('.sk-industry-sec');
    var img = section ? section.querySelector('[data-industry-img]') : null;
    var imgOn = section ? section.querySelector('[data-industry-img-on]') : null;
    var container = section ? section.querySelector('[data-industry-map-container]') : null;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var mapAsset = tab.getAttribute('data-industry-map');
        var mapOnAsset = tab.getAttribute('data-industry-map-on');
        if (img && mapAsset) {
          var basePath = img.src.split('/assets/')[0] + '/assets/';
          img.src = basePath + mapAsset;
          if (imgOn && mapOnAsset) {
            imgOn.src = basePath + mapOnAsset;
            imgOn.style.opacity = '0';
          }
        }
      });
    });

    if (container) {
      container.addEventListener('mouseenter', function() {
        if (imgOn) imgOn.style.opacity = '1';
      });
      container.addEventListener('mouseleave', function() {
        if (imgOn) imgOn.style.opacity = '0';
      });
    }
  });

  /* ===== Feature Slider ===== */
  var featureRow = document.querySelector('[data-feature-slider]');
  if (featureRow) {
    var fTrack = featureRow.querySelector('.sk-feature-track');
    var fPrev = featureRow.querySelector('.sk-feat-prev');
    var fNext = featureRow.querySelector('.sk-feat-next');
    if (fTrack && fPrev && fNext) {
      fPrev.addEventListener('click', function() {
        fTrack.scrollBy({ left: -300, behavior: 'smooth' });
      });
      fNext.addEventListener('click', function() {
        fTrack.scrollBy({ left: 300, behavior: 'smooth' });
      });
    }
  }

  /* ===== Wishlist (お気に入り) ===== */
  window.SKWishlist = {
    KEY: 'sk_wishlist',
    get: function() {
      try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch(e) { return []; }
    },
    has: function(handle) {
      return this.get().indexOf(handle) !== -1;
    },
    toggle: function(handle) {
      var list = this.get();
      var idx = list.indexOf(handle);
      if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
      localStorage.setItem(this.KEY, JSON.stringify(list));
      this.updateUI();
      return idx === -1;
    },
    count: function() { return this.get().length; },
    updateUI: function() {
      var badge = document.getElementById('wishlistCount');
      if (badge) {
        var c = this.count();
        badge.textContent = c;
        badge.style.display = c > 0 ? '' : 'none';
      }
      document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
        var h = btn.getAttribute('data-wishlist-btn');
        if (SKWishlist.has(h)) { btn.classList.add('active'); } else { btn.classList.remove('active'); }
      });
    }
  };
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-wishlist-btn');
      SKWishlist.toggle(handle);
    }
  });
  SKWishlist.updateUI();

});
